
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral/[id]",
      function () {
        return require("private-next-pages/funeral/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral/[id]"])
      });
    }
  